import axios, { AxiosResponse } from "axios"

export interface AuthResponse {
  Type: number
  Message: string
  Value: AuthData
  Validates?: any
}
  
export interface AuthData {
    Companies: Company[]
    ModuleId: number
    UserName: string
    FullName: string
    FirstName: string
    LastName: string
    MiddleName: string
    UserId: number
    IsInvitationUser: boolean
    CorporationURL: any
    Roles?: Company['Roles']
}

export interface Company {
    Id: number
    CorporationId: number
    Name: string
    Logo: any
    SchemaName: string
    RUC: string
    Ruc: string
    DatabaseNameERP: string
    Code: string
    IsActive: boolean
    Token: string
    CorporationModuleId: number
    HasCorporationURL: boolean
    Projects: any[]
    Roles: Roles
}

export interface Roles {
    Id: number
    Name: string
    IsAdministrator: boolean
    Access: Access[]
    }

export interface Access {
    Id: number;
    SecurityRoleId: number;
    SecurityAccessId: number;
    IsStartPage: boolean;
    Name: string;
    ItemPath: string;
    Icon: string;
    Visible: boolean;
    ParentId?: number;
    Order: number;
    Level: number;
    children?: Access[],
    urlPath: string
}


export interface ChangePasswordRequest {
    CurrentPassword: string;
    NewPassword: string;
    ConfirmNewPassword: string;
}


const authApi = axios.create({
    baseURL: process.env.REACT_APP_AUTH_API,
});

export const recoverPasswordRequest = async (userEmail: string) => {
	const resp: AxiosResponse<AuthResponse> = await authApi.post('/SendNewPassword', {
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessTypeId: process.env.REACT_APP_AUTH_TYPE,
		Email: userEmail,
	});
	return resp;
}